var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "memberUploadMediaModal",
      "modal-class": "client-details-modal",
      "centered": "",
      "size": "lg",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "hide-header-close": ""
    },
    on: {
      "shown": _vm.fetchFiles
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "view-clients-header"
        }, [_c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-container', {
    ref: "memberDocContainer",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "form-part"
  }, [_c('div', {
    staticClass: "title-text text-center mb-3"
  }, [_c('h5', [_c('strong', [_vm._v("Upload Media & Files")])])]), _c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('label', {
    attrs: {
      "for": "file-name"
    }
  }, [_vm._v("File Title "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.title,
      expression: "title"
    }],
    staticClass: "memberSearch-field col-6 mt-2",
    attrs: {
      "type": "text",
      "id": "file-name",
      "placeholder": "Title"
    },
    domProps: {
      "value": _vm.title
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value;
      }, _vm.resetTitleError]
    }
  }), _vm.titleError ? _c('div', {
    staticClass: "form-error error-font-size mt-2"
  }, [_vm._v(" " + _vm._s(_vm.titleError) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "file-upload-container",
    on: {
      "click": _vm.triggerFileInput
    }
  }, [_c('i', {
    staticClass: "fas fa-file-excel"
  }), _c('span', [_vm._v("Click to select files and media.")]), _c('input', {
    ref: "fileInput",
    staticClass: "d-none",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleFileChange
    }
  })]), _vm.errorExcelError ? _c('div', {
    staticClass: "form-error error-font-size mt-2 pl-2"
  }, [_vm._v(" " + _vm._s(_vm.errorExcelError) + " ")]) : _vm._e(), _vm.fileName ? _c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "mb-2 excel-file-title"
  }, [_vm._v("Selected File:")]), _c('div', {
    staticClass: "file-list-item"
  }, [_c('span', {
    staticClass: "file-item-name"
  }, [_vm._v(_vm._s(_vm.fileName))]), _c('span', {
    staticClass: "file-item-actions"
  }, [_c('button', {
    staticClass: "file-action-btn file-action-view",
    attrs: {
      "type": "button",
      "title": "View"
    },
    on: {
      "click": _vm.viewSelectedFile
    }
  }, [_c('i', {
    staticClass: "fas fa-eye"
  })]), _c('button', {
    staticClass: "file-action-btn file-action-download",
    attrs: {
      "type": "button",
      "title": "Download"
    },
    on: {
      "click": _vm.downloadSelectedFile
    }
  }, [_c('i', {
    staticClass: "fas fa-download"
  })]), _c('button', {
    staticClass: "file-action-btn file-action-delete",
    attrs: {
      "type": "button",
      "title": "Remove"
    },
    on: {
      "click": _vm.confirmDeleteFile
    }
  }, [_c('i', {
    staticClass: "fas fa-trash"
  })])])])]) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('button', {
    staticClass: "group-univ-btn text-center mt-0",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.uploadFile
    }
  }, [_vm._v(" Submit ")])])])]), _vm.files.length > 0 ? _c('div', {
    staticClass: "view-clients-modal-content"
  }, [_c('h6', [_vm._v("File List")]), _c('ul', {
    staticClass: "client-docs"
  }, [_vm._l(_vm.files, function (fileItem, fileItemIndex) {
    return _vm._l(fileItem.files, function (file, subIndex) {
      return _c('li', {
        key: subIndex,
        staticClass: "file-list-item"
      }, [_c('b-form-checkbox', {
        attrs: {
          "id": "checkbox-".concat(fileItemIndex, "-").concat(subIndex),
          "name": "checkbox-".concat(fileItemIndex, "-").concat(subIndex),
          "value": file
        },
        model: {
          value: _vm.form.data,
          callback: function callback($$v) {
            _vm.$set(_vm.form, "data", $$v);
          },
          expression: "form.data"
        }
      }), _c('span', {
        staticClass: "file-item-name"
      }, [_vm._v(_vm._s(fileItem.title))]), _c('span', {
        staticClass: "file-item-actions"
      }, [_c('a', {
        staticClass: "file-action-btn file-action-view",
        attrs: {
          "href": file.filepath,
          "target": "_blank",
          "title": "View"
        }
      }, [_c('i', {
        staticClass: "fas fa-eye"
      })]), _c('button', {
        staticClass: "file-action-btn file-action-download",
        attrs: {
          "type": "button",
          "title": "Download"
        },
        on: {
          "click": function click($event) {
            return _vm.downloadFile(file.filepath, fileItem.title);
          }
        }
      }, [_c('i', {
        staticClass: "fas fa-download"
      })]), _c('button', {
        staticClass: "file-action-btn file-action-delete",
        attrs: {
          "type": "button",
          "title": "Delete"
        },
        on: {
          "click": function click($event) {
            return _vm.deleteUploadedFile(file, fileItemIndex, subIndex);
          }
        }
      }, [_c('i', {
        staticClass: "fas fa-trash"
      })])])], 1);
    });
  })], 2), _c('div', {
    staticClass: "file-note mt-3"
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  }), _c('span', [_vm._v("Please choose one or many files to be sent in an email.")])]), _c('button', {
    staticClass: "btn univ-btn btn-secondary",
    attrs: {
      "type": "button",
      "disabled": _vm.isDisable
    },
    on: {
      "click": _vm.sendCardEmail
    }
  }, [_vm._v(" " + _vm._s(_vm.isSend ? "Sending File" : "Send File") + " ")])]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }